export default {"src":"/_next/static/image/src/assets/tick.da94640acb12cd2adc8c96ae52f49600.svg","height":24,"width":24};